import { attempt } from 'lodash'

const resetAntForm = (form, callback) => {
  form.resetFields()
  attempt(callback)
}

export default resetAntForm
